import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import axios from "../../api/axiosConfig";

// Site-owner route guard. Verifies the sa_token against /superadmin/me
// on mount so a revoked token or stale localStorage doesn't sneak the
// caller into the console. Compare POS's SAProtectedRoute.
const SAProtectedRoute = ({ children }) => {
  const [state, setState] = useState({ loading: true, ok: false });

  useEffect(() => {
    let cancelled = false;
    const token = localStorage.getItem("sa_token");
    if (!token) {
      setState({ loading: false, ok: false });
      return;
    }
    axios
      .get("/superadmin/me")
      .then((res) => {
        if (cancelled) return;
        if (res.data?.superAdmin) {
          localStorage.setItem("superAdmin", JSON.stringify(res.data.superAdmin));
          setState({ loading: false, ok: true });
        } else {
          setState({ loading: false, ok: false });
        }
      })
      .catch(() => {
        if (cancelled) return;
        localStorage.removeItem("sa_token");
        localStorage.removeItem("superAdmin");
        setState({ loading: false, ok: false });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
  if (!state.ok) {
    return <Navigate to="/super-admin-login" replace />;
  }
  return children;
};

export default SAProtectedRoute;
